import React from 'react';

export const SearchContext = React.createContext({
    currentUser: undefined,
    categories: undefined,
});



// WEBPACK FOOTER //
// ./src/js/apps/find-designers/components/SearchContext.ts